import React, { useState } from "react";
import axios from "utils/axios";
import { MdOutlineVideocam } from "react-icons/md";
import { LiaCommentSolid } from "react-icons/lia";
import { RxCross1 } from "react-icons/rx";
import Modal from "components/ui/Modal";
import CommentsBox from "components/ui/CommentsBox";
import CircularProgress from "components/ui/CircularProgress";

const VideoContainer = ({
  video,
  onDelete,
  viewMode = "grid",
  progress = 0,
  showDelete = true,
  uploadedSize,
  totalSize,
  eventId,
  propertyId,
}) => {
  const [commentsVisible, setCommentsVisible] = useState(false);

  const isUploading = progress > 0 && progress < 100;

  return (
    <div className="relative group border border-darkgray p-1">
      <div className="relative">
        {video?.url ? (
          <div
            className={`${viewMode === "grid" ? "h-24" : "max-h-[400px]"} w-full`}
          >
            <video
              className="w-full h-full object-cover"
              controls
              src={video.url}
              preload="metadata"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        ) : (
          <div
            className={`${viewMode === "grid" ? "h-24" : "max-h-[400px]"} w-full flex flex-col items-center justify-center bg-lightgray`}
          >
            <MdOutlineVideocam className="text-2xl text-darkgray mb-2" />
            <p className="w-full text-[10px] text-darkergray text-center leading-none">
              {video?.name}
            </p>
            <p className="text-[10px] text-darkergray text-center">
              {progress === 100 ? "Uploaded" : `${uploadedSize} / ${totalSize}`}
            </p>
          </div>
        )}

        {isUploading && (
          <div className="absolute inset-0 flex items-center justify-center">
            <CircularProgress value={progress} />
          </div>
        )}
      </div>

      {video?.comments?.length > 0 && (
        <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 p-1 flex items-center justify-center gap-2">
          <p className="text-white text-xs truncate">Revision</p>
          <div
            className="relative flex items-center cursor-pointer"
            onClick={async () => {
              setCommentsVisible(true);
              if (propertyId) {
                try {
                  // Change this route per repo:
                  // Contractor: "/prepareMarketing/status"
                  // Admin: "/admin/prepareMarketing/status"
                  await axios.post("/prepareMarketing/status", {
                    eventId,
                    propertyId,
                    status: "revisionInProgress",
                    type: "editedVideos",
                  });
                } catch (error) {
                  console.error("Error updating status:", error);
                }
              }
            }}
          >
            <LiaCommentSolid className="text-white w-5 h-5" />
            <span className="absolute top-0.5 right-0 w-1.5 h-1.5 bg-red-500 rounded-full" />
          </div>
        </div>
      )}

      {showDelete && (
        <div className="absolute -top-2 -right-2 flex space-x-2 items-center">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            className="bg-mediumgray rounded-full p-1 hover:bg-darkgray"
          >
            <RxCross1 className="text-black text-xs" />
          </button>
        </div>
      )}

      <Modal
        isOpen={commentsVisible}
        onClose={() => setCommentsVisible(false)}
        title="Comments"
      >
        <CommentsBox comments={video?.comments} imageId={video.id} />
      </Modal>
    </div>
  );
};

export default VideoContainer;
